export const PROFILE_PUSH_POPUP_ENABLED = false;

const isProfilePushFreezeActive = () => {
    return PROFILE_PUSH_POPUP_ENABLED
}

export default isProfilePushFreezeActive;